export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/passwordForget';
export const EVENTLIST = '/eventlist';
export const EVENTS ='/events';
export const ADDEVENT ='/addevent';
export const CANIDATELIST = '/canidatelist'
export const ADMINHOME = '/adminhome'
export const ADMINCANIDATELIST = '/admincanidates'
export const ADMINCANIDATEDETAILS = '/admincanidatedetails'
export const ADMINEVENTDETAILS_WITH_CANIDATES ='/admineventwithcanidates'
export const MESSAGINGDASHBOARD = '/messagingDashboard'
export const MY_MESSAGING_CENTER = '/myMessagingCenter'
export const ADMINEVENTS = '/adminEvents'
export const ADMINEVENTDETAILS_WITHOUT_CANIDATES = '/admineventwithoutcanidate'
export const ADMIN_CONNECTED_EVENTS = '/adminConnectedEvents'
export const ADMIN_CONFIRMED_EVENTS = '/adminConfirmedEvents'
export const CANIDATE_CONFIRMED_LIST = '/canidateConfirmedList'
export const ADMIN_USER_MGM = '/adminUserManagement'
export const ADMIN_UNLOCKED_USER = '/adminAppUser'
export const ADMIN_USERS_ONLINE = '/adminUserOnline'
export const ADMIN_ADD_EVENT = '/adminAddEvent'
export const DATENSCHUTZ = '/datenschutzerklaerung'



// WEBPACK FOOTER //
// ./src/constants/routes.js